import React from "react"
import PropTypes from "prop-types"
import { useTranslation } from "react-i18next"

// Build a "code — label" display from an option, tolerating either shape.
const optionLabel = (opt) => {
  const code = opt.code ?? opt.suffix
  return opt.label ? `${code} — ${opt.label}` : `${code}`
}

export default function MovementParams({ options, values, onChange, disabled }) {
  const { t } = useTranslation()

  const moveTypes = options.move_types || []
  const moveReasons = options.move_reasons || []
  const deposits = options.deposits || []

  const select = ({ id, labelKey, ariaLabel, field, opts, valueKey }) => (
    <div>
      <label htmlFor={id} className="block text-sm font-medium text-gray-700 mb-1">
        {t(`natura_operations.deposit_transfer.${labelKey}`)}
      </label>
      <select
        id={id}
        aria-label={ariaLabel}
        value={values[field] || ""}
        disabled={disabled}
        onChange={(e) => onChange({ [field]: e.target.value })}
        className="w-full text-sm border border-gray-300 rounded p-2 disabled:bg-gray-100 bg-white"
      >
        <option value="">{t("natura_operations.deposit_transfer.select_placeholder")}</option>
        {opts.map((opt) => {
          const value = opt[valueKey]
          return (
            <option key={value} value={value}>
              {optionLabel(opt)}
            </option>
          )
        })}
      </select>
    </div>
  )

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
      {select({
        id: "dt-move-type",
        labelKey: "move_type",
        ariaLabel: "move_type",
        field: "move_type",
        opts: moveTypes,
        valueKey: "code",
      })}
      {select({
        id: "dt-move-reason",
        labelKey: "move_reason",
        ariaLabel: "move_reason",
        field: "move_reason",
        opts: moveReasons,
        valueKey: "code",
      })}
      {select({
        id: "dt-source-deposit",
        labelKey: "source_deposit",
        ariaLabel: "source_deposit",
        field: "source_deposit",
        opts: deposits,
        valueKey: "suffix",
      })}
      {select({
        id: "dt-destination-deposit",
        labelKey: "destination_deposit",
        ariaLabel: "destination_deposit",
        field: "destination_deposit",
        opts: deposits,
        valueKey: "suffix",
      })}
    </div>
  )
}

MovementParams.propTypes = {
  options: PropTypes.shape({
    move_types: PropTypes.array,
    move_reasons: PropTypes.array,
    deposits: PropTypes.array,
  }),
  values: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
}

MovementParams.defaultProps = {
  options: {},
  disabled: false,
}
